// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

var $ = require('jquery');

var smoothscroll = require('../../node_modules/smoothscroll-polyfill');
smoothscroll.polyfill();

$(function() {
  $('.nav-item a').on('click', function(e) {
    var $el = $(this);
    var selector = $el.attr('href');
    var target = $(selector);
    if (target.length)
      target[0].scrollIntoView({ behavior: 'smooth', block: 'start' });

    return false;
  });

  $('.js-share--twitter').attr('href', "https://twitter.com/share?url="+window.location+"&text="+encodeURIComponent("Better Capitalism: The key to future economic growth is about more than just increasing shareholder value."));
  $('.js-share--facebook').attr('href', "https://www.facebook.com/sharer/sharer.php?u="+window.location);

});
